import moment from 'moment';
import { FETCH_VEHICLE_DRIVING_TIME, RESET_COMPANY_CONTEXT } from '../../actions';

const drivingTimesInitState = {
  loading: false,
  error: null,
  lastUpdated: moment(),
  data: [],
};

export function drivingTimesReducer(state = drivingTimesInitState, { type, payload, meta }) {
  switch (type) {
    case FETCH_VEHICLE_DRIVING_TIME.SUCCESS: {
      if (state.actionId !== meta.previousAction.payload.actionId) {
        return state;
      }
      return {
        ...state,
        data: payload.data,
        loading: false,
        error: null,
        lastUpdated: moment(),
      };
    }
    case FETCH_VEHICLE_DRIVING_TIME.FAIL:
      if (state.actionId !== meta.previousAction.payload.actionId) {
        return state;
      }
      return {
        ...state, loading: false, error: payload, data: [], lastUpdated: moment(),
      };
    case FETCH_VEHICLE_DRIVING_TIME.START:
      return { ...state, loading: true, actionId: payload.actionId };
    case RESET_COMPANY_CONTEXT:
      return { ...drivingTimesInitState };
    default:
      return state;
  }
}
